import React, { memo, useState, useCallback } from 'react';
import { createUseStyles, useTheme } from '@Sage/hoi-poi-ui';
import RichText from "../../../../../components/RichText";
import { useWeb5Context } from "../../../../../lib/Web5Context";
import ClearButton from "../ClearButton";
import SpeechButton from "../SpeechButton";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CopilotChatToolbar');
const ChatToolbar = /*#__PURE__*/memo(_ref => {
  var _Object$keys;
  let {
    conversation,
    isDanaWritting,
    onClear,
    getQuestionRef,
    onSubmit,
    isLoadingAnswer,
    placeholder,
    locale
  } = _ref;
  const classes = useStyles();
  const theme = useTheme();
  const {
    t
  } = useWeb5Context();
  const [isListening, setIsListening] = useState(false);
  const [editor, setEditor] = useState(null);
  const canSubmit = useCallback(editorContent => {
    if (!(editorContent !== null && editorContent !== void 0 && editorContent.text)) return false;
    return true;
  }, []);
  const getEditorRef = useCallback(ref => {
    var _ref$commands, _ref$commands2;
    if (ref !== null && ref !== void 0 && (_ref$commands = ref.commands) !== null && _ref$commands !== void 0 && _ref$commands.focus) ref === null || ref === void 0 ? void 0 : (_ref$commands2 = ref.commands) === null || _ref$commands2 === void 0 ? void 0 : _ref$commands2.focus();
    setEditor(ref);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, ((_Object$keys = Object.keys(conversation || {})) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0 && /*#__PURE__*/React.createElement(ClearButton, {
    onClick: !isDanaWritting && !isLoadingAnswer && onClear
  }), /*#__PURE__*/React.createElement(RichText, {
    isBasic: true,
    isFullWidth: true,
    placeholder: placeholder || t('placeholder_dana_chat_input'),
    toolbar: [],
    overrides: {
      editor: {
        style: {
          maxHeight: 120,
          // equals to 5 lines of text
          overflow: 'hidden'
        }
      },
      editorWrapper: {
        style: {
          backgroundColor: theme.colors.background.utility025
        }
      }
    },
    onChange: value => getQuestionRef === null || getQuestionRef === void 0 ? void 0 : getQuestionRef(value.text),
    onSubmit: onSubmit,
    loading: isDanaWritting,
    canSubmit: isListening ? () => false : canSubmit,
    autofocus: !isLoadingAnswer,
    getEditorRef: getEditorRef,
    isSubmitDisabled: isListening,
    chatbox: true
  }), /*#__PURE__*/React.createElement(SpeechButton, {
    editor: editor,
    isDisabled: isDanaWritting,
    setIsListening: setIsListening,
    isListening: isListening,
    locale: locale
  }));
});
export default ChatToolbar;